/**
 * Site slider setup.
 *
 * @see http://jquery.malsup.com/cycle2/api/
 */
(function($) {
    var breakpoint = 768;
    var throttle = 250;
    var ref, timestamp = 0;
    // remove sentinel height calc
    $(document).on('cycle-destroyed', '.site-slider', function(){
        var slideshow = $(this);
        setTimeout(function(){
            slideshow.removeAttr('style');
        }, 100);
    });
    function enableSlider(selector) {
        $(selector).each(function(){
            var slideshow = $(this);
            if ($('.site-slider__slide', slideshow).length > 1) {
                slideshow.cycle();
            }
        });
    }
    function setup() {
        if (Date.now() > timestamp) {
            timestamp = Date.now() + throttle;
            if ($(document).width() >= breakpoint) {
                enableSlider('.site-slider');
            } else {
                $('.site-slider.mobile-disabled').cycle('destroy');
            }
        }
    }
    $(window).on('resize', function(){
        setup();
        clearTimeout(ref);
        ref = setTimeout(function(){
            timeout = 0;
            setup();
        }, throttle);
    });
    setup();
    enableSlider('.site-slider.mobile-enabled');
})(jQuery);

/**
 * Home page primary slide background rotation.
 */
(function($) {
    function isMobile() {
        return -1 !== document.body.className.indexOf('is-mobile');
    }
    var duration = $('.site-slider__slide-preview').data('duration');
    var items = $('.site-slider__slide-preview-image', '.site-slider__slide--ai-driven').addClass('animated slower');
    items.first().addClass('current');
    if (isMobile()) return;
    items.each(function(){
        var bgImage = $(this).data('backgroundImage');
        if (!bgImage) return;
        $(this).css('background-image', 'url('+ bgImage +')');
    });
    function nextItem() {
        var currentEl = items.filter('.current');
        var nextEl = currentEl.next().length ? currentEl.next() : items.first();
        currentEl.removeClass('fadeIn fadeOut current').addClass('fadeOut');
        nextEl.removeClass('fadeIn fadeOut').addClass('fadeIn current');
    }
    setInterval(nextItem, duration?duration:4000);
})(jQuery);
